// Angular Modules
import { NgModule } from "@angular/core";
import { DatePipe, CommonModule as NgCommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Primeng Modules
import { AutoCompleteModule } from "primeng/autocomplete";
import { AvatarModule } from "primeng/avatar";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CheckboxModule } from "primeng/checkbox";
import { ChipModule } from "primeng/chip";
import { ColorPickerModule } from "primeng/colorpicker";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { DragDropModule } from "primeng/dragdrop";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { ImageModule } from "primeng/image";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextareaModule } from "primeng/inputtextarea";
import { InputTextModule } from "primeng/inputtext";
import { ListboxModule } from "primeng/listbox";
import { OrderListModule } from "primeng/orderlist";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessageModule } from "primeng/message";
import { MultiSelectModule } from "primeng/multiselect";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from "primeng/radiobutton";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from "primeng/steps";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TreeModule } from "primeng/tree";

// Components
import { DateTimePickerComponent } from "@/common/components/datetime-picker/datetime-picker.component";
import { PageContainerComponent } from "@/common/components/page-container/page-container.component";
import { UserProfileComponent } from "@/common/components/user-profile/user-profile.component";
import { SubscriptionsComponent } from "@/common/components/subscriptions/subscriptions.component";
import { DynamicPageComponent } from "@/common/components/dynamic-page/dynamic-page.component";
import { PagenotfoundComponent } from "@/modules/errors/pagenotfound/pagenotfound.component";

// Pipes
import { SafeHtmlPipe } from "@/common/pipes/safeHtml.pipe";

// Services
import { MessageService } from "@/common/services/message.service";

@NgModule({
  declarations: [
    PagenotfoundComponent,
    DateTimePickerComponent,
    PageContainerComponent,
    UserProfileComponent,
    SubscriptionsComponent,
    DynamicPageComponent,
    SafeHtmlPipe,
  ],
  imports: [
    // Import Angular Modules
    NgCommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // Import Primeng Modules
    AutoCompleteModule,
    AvatarModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CheckboxModule,
    ChipModule,
    ColorPickerModule,
    ConfirmDialogModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DragDropModule,
    DropdownModule,
    FieldsetModule,
    FileUploadModule,
    ImageModule,
    InplaceModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextareaModule,
    InputTextModule,
    ListboxModule,
    OrderListModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MultiSelectModule,
    PanelModule,
    PanelMenuModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ScrollPanelModule,
    SelectButtonModule,
    SidebarModule,
    SkeletonModule,
    SplitButtonModule,
    StepsModule,
    TableModule,
    TabViewModule,
    TagModule,
    ToastModule,
    ToggleButtonModule,
    TreeModule,
  ],
  exports: [
    // Export Angular Common Modules
    NgCommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // Export Primeng Modules
    AutoCompleteModule,
    AvatarModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CheckboxModule,
    ChipModule,
    ColorPickerModule,
    ConfirmDialogModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DragDropModule,
    DropdownModule,
    FieldsetModule,
    FileUploadModule,
    ImageModule,
    InplaceModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextareaModule,
    InputTextModule,
    ListboxModule,
    OrderListModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MultiSelectModule,
    PanelModule,
    PanelMenuModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ScrollPanelModule,
    SelectButtonModule,
    SidebarModule,
    SkeletonModule,
    SplitButtonModule,
    StepsModule,
    TableModule,
    TabViewModule,
    TagModule,
    ToastModule,
    ToggleButtonModule,
    TreeModule,
    // Export Components
    DateTimePickerComponent,
    PageContainerComponent,
    UserProfileComponent,
    SubscriptionsComponent,
    DynamicPageComponent,
    PagenotfoundComponent,
  ],
  providers: [
    MessageService,
    DatePipe,
    SafeHtmlPipe,
  ],
})
export class CommonModule {}
